"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.isNotValid = exports.getDeviceIndex = exports.getDeviceId = exports.getDevice = void 0;
exports.loadCurrent = loadCurrent;
exports.loadDeviceData = loadDeviceData;
exports.setDeviceDate = setDeviceDate;
exports.setMeasurementTimeList = setMeasurementTimeList;
exports.setSelectedDevice = setSelectedDevice;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _deviceApi = require("../api/deviceApi");
var _ReadingDateRange = require("../components/ConsumptionVisSharedComponents/VisualizationDateRange/ReadingDateRange");
var _dateValidation = require("../components/ConsumptionVisSharedComponents/VisualizationDateRange/date-validation");
var _SessionHandler = _interopRequireDefault(require("../utils/SessionHandler"));
var _Router = _interopRequireDefault(require("../../utils/Router"));
var _rlm = require("./rlm");
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_CURRENT_DEVICES = 'api/reducer/GET_DEVICES';
var SET_SELECTED_DEVICE = 'api/reducer/DEVICE';
var LOAD_CURRENT_DEVICE_DATA = 'api/reducer/GET_DEVICE_DATA';
var LOAD_CURRENT_DEVICE_DATA_STARTED = 'api/reducer/LOAD_CURRENT_DEVICE_DATA_STARTED';
var LOAD_CURRENT_DEVICE_DATA_FAILURE = 'api/reducer/LOAD_CURRENT_DEVICE_DATA_FAILURE';
var SET_DEVICE_DATE = 'api/reducer/DEVICE_DATE';
var SET_START_TIME = 'api/reducer/START_TIME';
var getDeviceId = exports.getDeviceId = function getDeviceId(device) {
  return "".concat(device.serialNumber, "-").concat(device.contractAccount, "-").concat(device.obis);
};
var getDeviceIndex = exports.getDeviceIndex = function getDeviceIndex(devices, deviceId) {
  return devices && devices.find ? devices.findIndex(function (elem) {
    return getDeviceId(elem) === deviceId;
  }) : null;
};
var getDevice = exports.getDevice = function getDevice(devices, deviceId) {
  return devices && devices.find ? devices.find(function (elem) {
    return getDeviceId(elem) === deviceId;
  }) : null;
};
var isNotValid = exports.isNotValid = function isNotValid(devices) {
  return Array.from(devices.map(function (device) {
    return device.dateRanges && device.dateRanges.length > 0 && (0, _dateValidation.isDateBefore)((0, _ReadingDateRange.fixMonth)(device.dateRanges[device.dateRanges.length - 1].valid && device.dateRanges[device.dateRanges.length - 1].valid.to), new Date());
  }));
};
function setPermissionByDevice(contractId) {
  var dataCachedContracts = _CacheHandler.default.getCurrentCacheByToken('contractaccounts');
  if (dataCachedContracts && dataCachedContracts.data) {
    _SessionHandler.default.setPermissions(dataCachedContracts.data.content, contractId);
  }
}

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var getPreselectedDevice = function getPreselectedDevice(devices) {
    var id = _Router.default.getParameter('deviceId');
    if (id) {
      return id;
    }
    if (devices[0]) {
      _Router.default.setParameter({
        deviceId: getDeviceId(devices[0])
      });
      return getDeviceId(devices[0]);
    }
    return null;
  };
  switch (action.type) {
    case LOAD_CURRENT_DEVICES:
      // set permission depending on device, avoid wrong default contract mismatching to the device
      if (action.data.innerData && action.data.innerData[0]) {
        setPermissionByDevice(action.data.innerData[0].contractAccount);
      }
      return _objectSpread(_objectSpread({}, state), {}, {
        devicesList: action.data.innerData,
        deviceValidStatus: isNotValid(action.data.innerData),
        deviceId: getPreselectedDevice(action.data.innerData)
      });
    case SET_SELECTED_DEVICE:
      _Router.default.setParameter({
        deviceId: action.data.deviceId
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        deviceId: action.data.deviceId
      });
    case LOAD_CURRENT_DEVICE_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        deviceData: [action.data.innerData]
      });
    case SET_DEVICE_DATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedStartDate: action.data.dateFrom,
        selectedEndDate: action.data.dateTo
      });
    case SET_START_TIME:
      return _objectSpread(_objectSpread({}, state), {}, {
        measurementData: {
          interval: state.deviceData[0].intervalSec * 1000,
          standardInterval: state.deviceData[0].intervalSec * 1000,
          unit: state.deviceData[0].unit,
          contractSpecificValues: (0, _rlm.getContractSpecificItems)(state.deviceData, 'smartmeter')
        },
        deviceDataProcceding: false,
        apiErrorCode: null
      });
    case LOAD_CURRENT_DEVICE_DATA_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        deviceDataProcceding: false,
        apiErrorCode: action.data.error
      });
    case LOAD_CURRENT_DEVICE_DATA_STARTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        deviceDataProcceding: true
      });
    default:
      return state;
  }
}

// Action Creators
function loadCurrent(dispatch, disabledHanDeviceOnly) {
  var resp = disabledHanDeviceOnly ? (0, _deviceApi.getDevices)() : (0, _deviceApi.getHanDevices)();
  return resp.then(function (reponse) {
    dispatch({
      type: LOAD_CURRENT_DEVICES,
      data: {
        innerData: reponse.data ? reponse.data.content : {}
      }
    });
  }).catch(function (err) {
    var _err$response, _err$response$data;
    var errorCode;
    if ((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.errors[0]) && err.response.data.errors[0].code) {
      errorCode = err.response.data.errors[0].code.split('.').pop();
    }
    dispatch({
      type: LOAD_CURRENT_DEVICE_DATA_FAILURE,
      data: {
        error: errorCode
      }
    });
  });
}
function setSelectedDevice(dispatch, deviceId, contractId) {
  _SessionHandler.default.resetPermissions();
  if (contractId) {
    setPermissionByDevice(contractId);
  }
  dispatch({
    type: SET_SELECTED_DEVICE,
    data: {
      deviceId: deviceId
    }
  });
}
function loadDeviceData(dispatch, serialNumber, obises, dateFrom, dateTo) {
  var resp = (0, _deviceApi.getDeviceData)(serialNumber, obises, dateFrom, dateTo);
  dispatch({
    type: LOAD_CURRENT_DEVICE_DATA_STARTED
  });
  return resp.then(function (response) {
    dispatch({
      type: LOAD_CURRENT_DEVICE_DATA,
      data: {
        innerData: response.data
      }
    });
  }).catch(function (err) {
    var errorCode;
    if (err.response.data.errors[0] && err.response.data.errors[0].code) {
      errorCode = err.response.data.errors[0].code.split('.').pop();
    }
    dispatch({
      type: LOAD_CURRENT_DEVICE_DATA_FAILURE,
      data: {
        error: errorCode
      }
    });
  });
}
function setDeviceDate(dispatch, dateFrom, dateTo) {
  dispatch({
    type: SET_DEVICE_DATE,
    data: {
      dateTo: dateTo,
      dateFrom: dateFrom
    }
  });
}
function setMeasurementTimeList(dispatch, time) {
  dispatch({
    type: SET_START_TIME,
    data: {
      time: time
    }
  });
}